/* eslint-disable */
export default {
    ca: {
        title: 'Enquesta d\'Instamaps',
        message: 'Si no coneixes l\'eina pots veure el vídeo formatiu d\'Instamaps al nostre canal de @YouTube',
        messageEmail: 'instamaps@icgc.cat',
        privacyPoliciesMsg: 'Enviant el teu email acceptes',
        privacyPoliciesLink: 'la política de privacitat',
        titleAturada: 'ATURADA PUNTUAL INSTAMAPS',
        messageAturada: 'Dimarts 19 de març hi haurà una aturada puntual d\'Instamaps de 7,30 a 8 del matí.',
        messageDisculpeu: 'Disculpeu les molèsties.',
        titleBrowser: 'Problemes amb el navegador?',
        messageBrowser: 'Instamaps és una eina web que utilitza el vostre navegador per a funcionar i per tant és imprescindible que el tingueu actualitzat per garantir el correcte funcionament de l’eina. ',
        messageBrowser2: 'Si no podeu actualitzar el vostre navegador perquè no sou administradors de l\'equip amb que treballeu podeu baixar-vos la versió portable del navegador Opera, que no necessita instal·lació ni permisos especials, des de l’enllaç ',
        enllacBrowser: 'https://www.opera.com/es/computer/portable',
        perSaberMes: 'Per saber-ne més',
        messageAltres: 'Si sou d\'una administració, institució, grup o empresa i voleu una formació a mida, escriviu-nos a ',        
        messageMestres:'Ja podeu provar les noves funcionalitats que hem desenvolupat per a què els docents pugueu utilitzar Instamaps amb els vostres alumnes! Contacteu amb nosaltres (',
        messageMestres2: ') per a qualsevol dubte que tingueu i per a suggerir-nos totes les millores que considereu.',
        messageMestres3: 'Més informació: ',
        messageEnquesta: 'Estem dissenyant una nova versió d\'INSTAMAPS',  
        messageEnquesta2: 'Ens pots ajudar a definir-lo contestant aquesta enquesta? Només són 5 minuts.',   
        messageEnquesta3: 'Anar a l\'enquesta',  
        titleMestres: 'INSTAMAPS PER A MESTRES'
    },
    es: {
        title: 'Encuesta de Instamaps',
        message: 'Si eres nuevo en la herramienta puedes ver el vídeo de la sesión de Instamaps en nuestro canal de @YouTube',
        messageEmail: 'instamaps@icgc.cat',
        privacyPoliciesMsg: 'Enviando tu email aceptas',
        privacyPoliciesLink: 'la política de privacidad',
        titleAturada: 'PARADA PUNTUAL INSTAMAPS',
        messageAturada: 'Martes 19 de marzo habrá una parada puntual de Instamaps de 7,30 a 8 de la mañana.',
        messageDisculpeu: 'Disculpen las molestias.',
        titleBrowser: 'Problemas con el navegador?',
        messageBrowser: 'Instamaps és una herramienta web que utiliza su navegador para funcionar y por lo tanto es imprescindible que esté actualizado para garantizar el correcto funcionamiento de la herramienta. ',
        messageBrowser2: 'Si no puede actualitzar su navegador porqué no es administrador del equipo en el que trabaja puede descargar la versión portable del navegador Opera, que no necessita instalación ni permisos especiales, desde el enlace ',
        enllacBrowser: 'https://www.opera.com/es/computer/portable',
        perSaberMes: 'Para saber más',
        messageAltres: 'Si es de una administración, institución, grupo o empresa y desea una formación a medida, escribid a ',        
        messageMestres:'Ya podeis probar las nuevas funcionalidades que hemos desarrollado para que los docuentes puedan utilizar Instamaps con vuestros alumnos! Contáctenos (',
        messageMestres2: ') para cualquier duda que tenga y para sugerirnos todas las mejoras que considere.',
        messageMestres3: 'Más información: ',
        messageEnquesta: '¡Estamos diseñando una nueva versión de INSTAMAPS',  
        messageEnquesta2: '¿Nos puedes ayudar a definirlo contestando esta encuesta? Son sólo 5 minutos.',   
        messageEnquesta3: 'Ir a la encuesta',   
        titleMestres: 'INSTAMAPS PARA MAESTROS'
    },
    en: {
        title: 'Instamaps survey',
        message: 'If you are new to the tool you can watch the video of the Instamaps session on our @YouTube channel',
        messageEmail: 'instamaps@icgc.cat',
        privacyPoliciesMsg: 'By sending your email you are accepting the',
        privacyPoliciesLink: 'privacy policies',
        titleAturada: 'PUNTUTAL STOP OF INSTAMAPS',
        messageAturada: 'On Tuesday, March 19 there will be a punctual stop of Instamaps from 7.30 a.m. to 8 in the morning.',
        messageDisculpeu: 'So sorry.',
        titleBrowser: 'Problems with the browser?',
        messageBrowser: 'Instamaps is a webapp that relies on your browser to work and thus it is mandatory to have an up to date version of the browser for Instamaps to function properly. ',
        messageBrowser2: 'If you can’t update your browser because you are not the administrator of the computer where you work you can download the portable version of Opera browser, which does not need to be installad nor requires special permissions, from this link ',
        enllacBrowser: 'https://www.opera.com/es/computer/portable',
        perSaberMes: 'For more information',
        messageAltres: 'If you are from an administration, institution, group or company and you want tailor-made training, write to us at ',
        messageMestres:'You can now try out the new features we have developed so that teachers can use Instamaps with your students! Contact us (',
        messageMestres2: ') for any questions you may have and to suggest any improvements you consider.',
        messageMestres3: 'More info: ',
        messageEnquesta: 'We are designing a new version of INSTAMAPS',  
        messageEnquesta2: 'Can you help us shape it by answering this survey? It will take just 5 minutes',   
        messageEnquesta3: 'Go to survey',  
        titleMestres: 'INSTAMAPS FOR TEACHERS'
    },
};



// WEBPACK FOOTER //
// ./src/home/components/info-modal/info-modal-translations.js